import React, { useEffect, useState } from "react";
import "./HeAppWrapper.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import Tooltip from "react-tooltip";

/**
 * This component is a wrapper for apps that keeps track on app sizing and provides a mechanism for showing a loading overlay.
 */
function HeAppWrapper(props) {
    const [state, setState] = useState({
        isAnimationComplete: false
    });
    useEffect(() => {
        if (!props.isLoadingOverlayVisible) {
            setTimeout(() => {
                setState({ isAnimationComplete: true });
            }, props.fadeOutTime * 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.isLoadingOverlayVisible]);

    const renderTooltip = () => {
        if (!props.tooltipContent || props.tooltipContent === "") return null;
        return (
            <Tooltip html={true} effect={"float"} delayShow={0}>
                {props.tooltipContent}
            </Tooltip>
        );
    };
    return (
        <div className={"HeAppWrapper sans " + props.className}>
            <div
                className="loading"
                style={{
                    opacity: props.isLoadingOverlayVisible ? 1 : 0,
                    display: state.isAnimationComplete ? "none" : "block",
                    transitionDuration: props.fadeOutTime.toString() + "s"
                }}
            >
                <div style={{ paddingTop: "calc(50vh - 20px)" }}>
                    <FontAwesomeIcon icon={faSpinner} spin size="4x" />
                </div>
            </div>
            <div data-tip="HeAppWrapper_Tooltip">
                {renderTooltip()}
                {props.children}
            </div>
        </div>
    );
}

HeAppWrapper.propTypes = {
    isLoadingOverlayVisible: PropTypes.bool,
    fadeOutTime: PropTypes.number,
    tooltipContent: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};
HeAppWrapper.defaultProps = {
    isLoadingOverlayVisible: false,
    fadeOutTime: 1,
    tooltipContent: null
};

export default HeAppWrapper;
